'use client';

import { useEffect } from 'react';
import env from '@trashlab/sitesapp/src/env';

// Add type declaration for our custom flag
declare global {
  interface Window {
    __GOOGLE_MAPS_LOADING: boolean;
  }
}

export function GoogleMapsLoader() {
  useEffect(() => {
    // Only load on client side
    if (typeof window === 'undefined') return;

    // Don't load if already loaded
    if (window.google && window.google.maps) {
      // Dispatch event for components that might be waiting
      document.dispatchEvent(new Event('google-maps-loaded'));
      return;
    }

    // Prevent duplicate loading in progress
    if (window.__GOOGLE_MAPS_LOADING) return;

    // Don't load if the script tag already exists
    if (document.getElementById('google-maps-script')) return;

    const apiKey = env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      console.error('Google Maps API key is missing');
      return;
    }

    try {
      // Set flag that loading is in progress
      window.__GOOGLE_MAPS_LOADING = true;

      // Create the script element
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,marker,geometry`;
      script.async = true;
      script.defer = true;
      script.id = 'google-maps-script';

      // Set up the loaded callback
      script.onload = () => {
        console.log('Google Maps script loaded');
        // Dispatch event for components that might be waiting
        document.dispatchEvent(new Event('google-maps-loaded'));
      };

      // Add the script to the document
      document.head.appendChild(script);
    } catch (error) {
      // Reset flag if loading fails
      window.__GOOGLE_MAPS_LOADING = false;
      console.error('Error loading Google Maps script:', error);
    }
  }, []);

  return null;
}
